import React from 'react';

import { useKioskManager } from '../../../hooks/useKioskManager';
import { useNetworkManager } from '../../../hooks/useNetworkManager';
import { useOutsideClick } from '../../../hooks/useOutsideClick';
import { Modal } from '../modal/Modal';
import styles from './callToActionModal.module.scss';

export type CallToActionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onCtaClick: () => void;
};
export const CallToActionModal: React.FC<CallToActionModalProps> = ({
  isOpen,
  onClose,
  onCtaClick,
}) => {
  const modalRef = useOutsideClick(onClose);
  const { callToActionImage } = useNetworkManager();
  const { kioskMode, kiosk } = useKioskManager();

  return (
    <Modal isOpen={isOpen}>
      <div
        className={`
        ${styles.webModal}
        ${kiosk && kioskMode && styles[kiosk.model]}
      `}
        ref={modalRef}
      >
        <div className={styles.ctaImageContainer}>
          <img
            src={callToActionImage}
            alt={'install_app_screen_image'}
            className={styles.ctaImage}
            onClick={() => {
              if (!kioskMode) {
                onCtaClick();
              }
            }}
          />
          <div
            className={styles.touchArea}
            onClick={onClose}
            data-testid="callToActionCloseModal"
          ></div>
        </div>
      </div>
    </Modal>
  );
};
